import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';

import { VacationDal } from '../dal/vacation.dal';

@Injectable({
  providedIn: 'root',
})
export class VacationService {
  constructor(private vacationDal: VacationDal) {}

  addVacation(vacation: any): Observable<any> {
    return this.vacationDal.addVacation(vacation);
  }

  getAllVacations() {
    return this.vacationDal.getAllVacations();
  }

  getOpenVacations() {
    return this.vacationDal.getOpenVacations();
  }

  getClosedVacations() {
    return this.vacationDal.getClosedVacations();
  }

  getOpenVacationsFromTo(
    startDate?: string,
    endDate?: string,
    position?: string,
    residency?: string,
    seniority?: string,
    page?: number,
    sortField?: string,
    sortDirection?: number
  ) {
    return this.vacationDal.getOpenVacationsFromTo(
      startDate,
      endDate,
      position,
      residency,
      seniority,
      page,
      sortField,
      sortDirection
    );
  }

  getClosedVacationsFromTo(
    startDate?: string,
    endDate?: string,
    position?: string,
    residency?: string,
    seniority?: string,
    page?: number,
    sortField?: string,
    sortDirection?: number
  ) {
    return this.vacationDal.getClosedVacationsFromTo(
      startDate,
      endDate,
      position,
      residency,
      seniority,
      page,
      sortField,
      sortDirection
    );
  }

  updateVacation(vacation: any) {
    return this.vacationDal.updateVacation(vacation);
  }

  updateVolunteers(vacation: any) {
    return this.vacationDal.updateVolunteers(vacation);
  }

  getVacationRequestHistory(profileId: string, showOnHold: boolean, startDate?: string, endDate?: string) {
    return this.vacationDal.getVacationRequestHistory(profileId, showOnHold, startDate, endDate);
  }

  deleteVacation(vacationID: string) {
    return this.vacationDal.deleteVacation(vacationID);
  }
}
